module.exports = __webpack_public_path__ + "static/media/kereses.ca33e4a7.jpg";